import React from 'react';
import Markup from './markup/Markup';


import 'react-18-image-lightbox/style.css';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'swiper/css';
import './css/plugins.css';
import './css/style.css';
import './css/templete.css';
import './css/skin/skin.css';
import './css/mobile.css';

import './plugins/bootstrap-select/bootstrap-select.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-modal-video/css/modal-video.min.css';


function App() {
	return (			
		<div className="App">
			<Markup />
		</div>	
	);
}

export default App;
